module.exports = __webpack_public_path__ + "img/right.a1445032.svg";